import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbAccordionConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { paths } from 'src/app/Shared/enums/paths.enum';
import { ModalService } from 'src/app/Shared/services';
import { CommonService } from 'src/app/Shared/services/common_services/common.service';
import { ReadingJsonService } from 'src/app/Shared/services/configuration_service/reading-json.service';
import { DataCommunicationService } from 'src/app/Shared/services/data_service/data-communication.service';
import { LoaderindicatorService } from 'src/app/Shared/services/loaderindicator/loaderindicator.service';

@Component({
  selector: 'mgfw-car-service-list',
  templateUrl: './car-service-list.component.html',
  styleUrls: ['./car-service-list.component.css']
})
export class CarServiceListComponent implements OnInit {

  brandName: string;
  modelName: string;
  licensePlate: any;
  vinNo: any;
  year: any;
  SelectedDealerName: any;
  IsSubmitted = true;
  PriceTotal = 0;
  selectedPackageName: any;
  SelectedPackageData = [];
  SelectedEUService = [];
  SelectedService = [];
  AccessoriesList = [];
  CustomerNotes = '';
  VehicleKilometer;
  RequiredKM = false;
  addKilometer = 0;
  BrandCode: any;
  pkkDate: any;
  isDeadlineForPKK: boolean;
  ModelImage: any;
  FuelType: any;
  FinalAdditionalService: any;
  ServiceListData: Array<any> = [];
  FinalService: any;
  packageListData: Array<any> = [];
  showOLBService: Boolean;
  BrandList: any;
  searchParams: any;
  PackagesDetailed: any;
  EUControlData: any;
  EUTotal = 0;
  EUDuration = 0;
  AdditionalTotal = 0;
  AddDuration = 0;
  OLBPrice = 0;
  OLBDuration = 0;
  serviceCount = 0;
  AdditionalTotalDuration = 0;
  OLBServicePrice = 0;
  OLBServiceDuration = 0;
  EUControlprice = 0; //1250;
  EUControlduration = 0;
  AdditionalTotalPrice = 0;
  accessoryTotalPrice: number = 0;
  DurationTotal = 0;
  AdditionalServiceCount = 0;
  EUControlCount = 0;
  showPrice: boolean;
  showServices = false;
  FinalPackageServiceData: any;
  requiredservice = [];
  TotalPrice = 0;
  TotalDuration = 0;
  selectedPackageId: any;
  modelPDF: any;
  PackageDetail: any;
  pdfPath = "";
  packages = [];
  PackagePrice = 0;
  PackageDuration = 0;
  currentDate = new Date();
  selectedGiftCards;

  constructor(
    public commonService: CommonService,
    private dataCommunicationService: DataCommunicationService,
    private loaderservice: LoaderindicatorService,
    protected readonly fb: FormBuilder,
    private translate: TranslateService,
    private readJsonFile: ReadingJsonService,
    private modalService: ModalService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.SelectedDealerName = this.commonService.getLocalStorageitem("SelectedDealerName");
    this.BrandCode = this.commonService.getLocalStorageByKey("vehicleData","BrandName");
    this.brandName = this.BrandCode + " " + this.commonService.getLocalStorageByKey("vehicleData", "ModelName");
    //this.brandName = this.commonService.getLocalStorageByKey("vehicleData", "BrandName");
    this.modelName = this.commonService.getLocalStorageByKey("vehicleData", "ModelName");
    this.licensePlate = this.commonService.getLocalStorageByKey("vehicleData", "LicensePlateNo");
    this.vinNo = this.commonService.getLocalStorageByKey("vehicleData", "VinNo");
    this.year = this.commonService.getLocalStorageByKey("vehicleData", "Year");
    var pkkdt = this.commonService.getLocalStorageByKey("vehicleData", "PKKDate");
    this.pkkDate = this.commonService.formatDate(new Date(pkkdt));
    this.isDeadlineForPKK = this.monthDiff(new Date, new Date(pkkdt)) > 6 ? false : true;
    this.ModelImage = this.commonService.getLocalStorageByKey("vehicleData", "ModelImage");
    this.FuelType = this.commonService.getLocalStorageByKey("vehicleData", "Fuelcode");
  }

  getCSSDynamic() {
    return this.commonService.getBrandTheme(this.BrandCode.toLocaleLowerCase());    
  }

  toggleShow() {
    const MitsubishiParentClass = document.querySelector("#carService");
    if (MitsubishiParentClass.classList.contains("os-open")) {
      MitsubishiParentClass.classList.remove("os-open");
    } else {
      MitsubishiParentClass.classList.add("os-open");
    }
  }

  public notesChange() {
    if (this.CustomerNotes !== undefined && this.CustomerNotes !== "" && this.CustomerNotes != null) {
      this.commonService.setLocalStorage("notes", this.CustomerNotes);
    } else {
      this.commonService.removeLocalStorage(["notes"]);
    }
  }

  monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  public ConfirmService() {
    var pkkservice = false;
    this.commonService.removeLocalStorage([
      "waitingTime",
      "dropTime",
      "RentalCar",
      "kiosk",
      "AppointDate",
      "AvailableDates",
    ]);

    this.currentDate = this.computeDate(new Date());
    if (this.TotalDuration != 0 || this.AdditionalTotalDuration != 0 || this.EUControlduration != 0) {
      const duration = Number(this.TotalDuration) + Number(this.AdditionalTotalDuration) + Number(this.EUControlduration);
      this.commonService.setLocalStorage("totalTime", this.timeConvert(duration));
    }
    else {
      this.commonService.setLocalStorage("totalTime", this.timeConvert(this.OLBDuration));
    }

    if (this.FinalPackageServiceData != null && this.FinalPackageServiceData.SelectedPackage.length > 0) {
      this.commonService.setLocalStorage("PackageServiceListData", this.FinalPackageServiceData);
    }

    if (this.AccessoriesList != null && this.AccessoriesList.length > 0) {
      this.commonService.setLocalStorage("SelectedAccessories", this.AccessoriesList.filter(x => x['isSelected'] == true));
    }

    if (this.CustomerNotes !== undefined && this.CustomerNotes !== "" && this.CustomerNotes != null) {
      this.commonService.setLocalStorage("notes", this.CustomerNotes);
    }

    if (this.commonService.getLocalStorage("SelectedEUService")) {
      pkkservice = true;
    }

    this.translate.get("LoaderText.loading").subscribe((message) => {
      this.loaderservice.show(message);
    });

    const appointmentCheckAvailabilityRequest: any = [];
    appointmentCheckAvailabilityRequest.TotalDuration = this.commonService.getLocalStorageitem("totalTime");
    appointmentCheckAvailabilityRequest.LicensePlate = this.commonService.getLocalStorageByKey("vehicleData", "LicensePlateNo");
    appointmentCheckAvailabilityRequest.Make = this.commonService.getLocalStorageByKey("vehicleData", "BrandName"),
    appointmentCheckAvailabilityRequest.PkkService = pkkservice;
    appointmentCheckAvailabilityRequest.DealerId = this.commonService.getLocalStorage("dealername");
    appointmentCheckAvailabilityRequest.StartDate = this.currentDate.getFullYear() + "-" + Number(this.currentDate.getMonth() + 1) + "-" + this.currentDate.getDate();

    if (
      this.commonService.getLocalStorageitem("waitingTime") != undefined &&
      this.commonService.getLocalStorageitem("waitingTime") != null &&
      this.commonService.getLocalStorageitem("waitingTime") != ""
    ) {
      appointmentCheckAvailabilityRequest["WaitTimeDropTime"] = this.commonService.getLocalStorageitem("waitingTime");
    }
    else if (
      this.commonService.getLocalStorageitem("dropTime") != undefined &&
      this.commonService.getLocalStorageitem("dropTime") != null &&
      this.commonService.getLocalStorageitem("dropTime") != ""
    ) {
      appointmentCheckAvailabilityRequest["WaitTimeDropTime"] = this.commonService.getLocalStorageitem("dropTime");
    }

    this.dataCommunicationService
      .checkAppointmentAvability(appointmentCheckAvailabilityRequest)
      .subscribe((result) => {
        // if (result.StatusCode === 1) {
        //   console.log(result.Data);
        // }
        //console.log('result', result)
        // this.commonService.setLocalStorage('unAvailableDates', result.Data.UnAvailableDates);
        // this.commonService.setLocalStorage('UnAvailableDatesForOccupied', result.Data.UnAvailableDatesForOccupied);
        // this.commonService.setLocalStorage('WeekDayList', result.Data.WeekDayList);
        this.commonService.setLocalStorage("AvailableDates", result.AvailableDates);
        if (this.selectedGiftCards != undefined) {
          this.commonService.setLocalStorage("selectedGiftCards", JSON.stringify(this.selectedGiftCards));
        }
        if (this.SelectedEUService != null && this.SelectedEUService.length > 0) {
          this.commonService.setLocalStorage("SelectedEUService", this.SelectedEUService);
        }
        this.commonService.NavigatePage(paths.CONFIRMBOOKING);
      },
        (error) => {
          this.loaderservice.hide();
          this.commonService.getErrorMessage("LoaderText.DMSDown");

        });
  }

  public getKilometer(e) {
    this.addKilometer = 0;
    if (e === "w") {
      if (this.VehicleKilometer != undefined && this.VehicleKilometer != null && this.VehicleKilometer != "") {
        this.RequiredKM = false;
        this.commonService.setLocalStorage("VehileKm", this.VehicleKilometer);
      } else {
        this.RequiredKM = true;
        this.commonService.setLocalStorage("VehileKm", 0);
        return;
      }
    } else {
      this.commonService.setLocalStorage("VehileKm", "---");
    }
    this.addKilometer = this.commonService.getLocalStorage("VehileKm");
  }

  public getPackagesData() {
    this.FinalService = [];
    this.packageListData = [];
    this.ServiceListData = [];
    this.SelectedEUService = [];
    this.FinalAdditionalService = [];
    this.commonService.removeLocalStorage([
      "serviceIDList",
      "SelectedService",
      "PackageServiceListData",
      "SelectedEUService",
    ]);
    if (this.VehicleKilometer == undefined) {
      this.VehicleKilometer = 0;
      this.commonService.setLocalStorage("VehileKm", 0);
    }
    this.getdealerConfigurationById(this.commonService.getLocalStorageitem("dealername"));
  }

  public getdealerConfigurationById(param: any) {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.dataCommunicationService
      .getDealersConfigurationById(param)
      .subscribe((result) => {
        if (result.StatusCode === 1) {
          this.loaderservice.hide();
          this.commonService.setLocalStorage("dealerConfig", result.Data);
          // if (result.Data.EnableMenuPricing == false) {
          //   this.getServiceList()
          //   this.showOLBService = true;
          // }
          // else {
          this.brandList(this.BrandCode);
          this.showOLBService = false;
          //}
        }
      });
  }

  public brandList(BrandCode: any): void {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.dataCommunicationService
      .getBrandById(this.BrandCode)
      .subscribe((result) => {
        if (result.StatusCode === 1) {
          this.loaderservice.hide();
          this.BrandList = result.Data;
          this.showOLBService = false;
          this.getPackageList();
        }
      });
  }

  public getPackageList() {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.searchParams = {
      licensePlate: this.licensePlate,
      VINNumber: this.vinNo,
      dealerId: this.commonService.getLocalStorage("dealername"),
      Kilometer: this.VehicleKilometer,
      BrandName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "BrandName"
      ),
      ModelName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "ModelName"
      ),
      IsOtherBrand: this.BrandList.MenuPricing === "WebCapri" ? false : true,
    };
    //this.searchParams = {licensePlate : this.licensePlate , dealerId :"031140", Kilometer : this.VehilceKilometer };
    this.dataCommunicationService.getAllPackages(this.searchParams).subscribe(
      (result) => {
        if (result.StatusCode === 1) {
          if (this.BrandCode == "Renault") this.ShowPopup("openModelPDF");
          this.loaderservice.hide();
          this.PackagesDetailed = result.Data;
          this.packageListData.push(this.PackagesDetailed);
          if (this.BrandList.MenuPricing === "WebCapri") {
            this.EUControlData = this.PackagesDetailed.EUControlaServices;
            this.FinalAdditionalService = this.PackagesDetailed.AdditionalServices;
            this.FinalAdditionalService.forEach(element => {
              element.LineAmountVat = Number(element.LineAmountVat.toFixed(0))
            });
            this.EUControlData.forEach(element => {
              element.LineAmountVat = Number(element.LineAmountVat.toFixed(0))
            });
          }
          else if (this.BrandList.MenuPricing === "MPO") {
            this.getMPOAdditionalService();
          }

          this.getServiceChecked();

          this.ServiceListData = [];
          this.FinalService = [];
          this.packageListData.forEach(p => {
            p.PackageDetail.forEach(pd => {
              pd.ServiceListData.forEach(pds => {
                pds.serviceTotal = Number(pds.serviceTotal.toFixed(0))
                this.ServiceListData.push(pds)
              });
            });
          })
          this.FinalService = this.ServiceListData;
          //this.FinalService[0].serviceTotal = 369.953
          //this.FinalService[1].serviceTotal = 131.235
          this.getPackageChecked();
        } else {
          // this.translate.get('LoaderText.noServiceFound').subscribe(message => {
          //   this.loaderservice.show(message);
          //   this.loaderservice.hide();
          // });
        }
      },
      (error) => {
        this.commonService.getErrorMessage("LoaderText.AlertMsg");
      }
    );
  }

  public getMPOServices(URL, indexprice, packageID) {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.searchParams = {
      licensePlate: this.licensePlate,
      dealerId: this.commonService.getLocalStorage("dealername"),
      Kilometer: this.VehicleKilometer,
      BrandName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "BrandName"
      ),
      ModelName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "ModelName"
      ),
      Url: URL,
      IsDetailsService: true,
      IsOtherBrand: true,
      VINNumber: this.vinNo,
    };

    this.dataCommunicationService
      .getAllPackages(this.searchParams)
      .subscribe((result) => {
        if (result.StatusCode === 1) {
          this.loaderservice.hide();
          const listData = result.Data.PackageDetail[0].ServiceListData[0];
          const indexAt = this.FinalService.findIndex((x) => x.PackageId == packageID);
          if (indexAt > -1) {
            this.FinalService[indexAt].PackageServiceList = listData.PackageServiceList;
            this.FinalService[indexAt].OptionalServiceDetailList = listData.OptionalServiceDetailList;
          }
          this.getPackagesDetails(this.FinalService[indexAt], packageID);
        }
      });
  }

  public getMPOAdditionalService() {
    this.translate.get("LoaderText.services").subscribe((message) => {
      this.loaderservice.show(message);
    });
    this.EUControlData = [];
    this.searchParams = {
      licensePlate: this.licensePlate,
      dealerId: this.commonService.getLocalStorage("dealername"),
      Kilometer: this.VehicleKilometer,
      BrandName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "BrandName"
      ),
      ModelName: this.commonService.getLocalStorageByKey(
        "vehicleData",
        "ModelName"
      ),
      PackageId: 0,
      IsDetailsService: true,
      IsOtherBrand: true,
      VINNumber: this.vinNo,
    };

    this.dataCommunicationService
      .getMPOAdditionalPackage(this.searchParams)
      .subscribe((result) => {
        //if (result.StatusCode === 1) {
        this.loaderservice.hide();
        this.FinalAdditionalService = result.AdditionalServices;
        this.FinalAdditionalService.forEach(element => {
          element.LineAmountVat = Number(element.LineAmountVat.toFixed(0))
        });
        //EU Control Service
        this.EUControlData = result.EUControlaServices;
        this.EUControlData.forEach(element => {
          element.LineAmountVat = Number(element.LineAmountVat.toFixed(0))
        });
        // }
      });
  }

  public getPackageChecked() {
    if (this.commonService.getLocalStorageitem("PackageServiceListData") != null) {
      //this.showServices = true;
      this.showServices = false;
      this.showPrice = true;
      this.IsSubmitted = false;
      this.SelectedPackageData = this.commonService.getLocalStorage("PackageServiceListData")["SelectedPackage"];

      this.SelectedPackageData = this.FinalService.filter((x) => x.PackageId == this.SelectedPackageData[0].PackageId);
      this.selectedPackageName = this.SelectedPackageData[0].PackageName;

      var PackageDetail = this.commonService.getLocalStorage("PackageServiceListData")["SelectedPackage"];
      var TotalPrice = this.commonService.getLocalStorage("PackageServiceListData")["TotalPrice"];
      var TotalDuration = this.commonService.getLocalStorage("PackageServiceListData")["TotalDuration"];

      this.FinalPackageServiceData = {
        SelectedPackage: PackageDetail,
        TotalPrice: TotalPrice,
        TotalDuration: TotalDuration,
      };
      this.selectedPackageId = this.FinalPackageServiceData.SelectedPackage[0].PackageId;
      this.TotalPrice = this.FinalPackageServiceData.TotalPrice;
      this.TotalDuration = this.FinalPackageServiceData.TotalDuration;
      var SelectedPackageServices = this.commonService.getLocalStorage("PackageServiceListData")["SelectedPackage"];
      this.requiredservice = SelectedPackageServices[0].SelectedPackageServices;
      if (this.BrandList.MenuPricing == "MPO") {
        this.SelectedPackageData[0].PackageServiceList = this.requiredservice;
      }
      this.PriceTotal = this.EUControlprice + this.AdditionalTotalPrice + this.accessoryTotalPrice +
        Number(this.commonService.getLocalStorage("PackageServiceListData")["TotalPrice"].toFixed(2));
    }
  }

  getPackage(packages: any, packageId) {
    if (this.BrandList.MenuPricing === "WebCapri") {
      //if(true){
      this.getPackagesDetails(packages, packageId);
    } else {
      if (packages == null || packages.PackageServiceList == null) {
        this.getMPOServices(packages.ServiceUrl, 0, packages.PackageId);
      } else {
        this.getPackagesDetails(packages, packageId);
      }
    }
  }

  getPackagesDetails(packages: any, packageId) {
    this.showPrice = false;
    //this.showServices = true;
    this.showServices = false;
    this.selectedPackageId = packageId;
    var otherCheckbox = true;

    this.commonService.removeLocalStorage(["PackageServiceListData"]);
    if (this.SelectedPackageData.length > 0) {
      if (this.SelectedPackageData.some((x) => x.PackageId === packages.PackageId)) {
        if (this.BrandList.MenuPricing === "WebCapri") {
          this.SelectedPackageData = [];
        } else {
          const indexAt = this.SelectedPackageData.findIndex((x) => x.PackageId === packages.PackageId);
          if (indexAt >= 0) {
            this.SelectedPackageData.splice(indexAt);
          } else {
            this.SelectedPackageData.push(packages);
            //this.getServicesOfPackages();
          }
        }
        otherCheckbox = false;
        // this.PackageSelection(false);
      } else {
        if (this.BrandList.MenuPricing === "WebCapri") {
          this.SelectedPackageData = [];
        }
        this.SelectedPackageData.push(packages);
        // this.getServicesOfPackages();
      }
    } else {
      this.SelectedPackageData = [];
      this.SelectedPackageData.push(packages);
      // this.getServicesOfPackages();
    }
    // earlier Code for Checkbox only
    // this.SelectedPackageData = [];
    // this.SelectedPackageData.push(packages);

    this.PackageSelection(otherCheckbox);
  }

  PackageSelection($event) {
    this.serviceCount = 0;
    this.PriceTotal = 0;
    this.selectedPackageName = 0;
    this.TotalPrice = 0;
    this.TotalDuration = 0;
    this.PackageDetail = [];
    this.FinalService.forEach((x) => (x.selectedPrice = x.serviceTotal));
    if ($event == false) {
      this.FinalPackageServiceData = [];
      this.serviceCount = 0;
      this.selectedPackageName = "";
    }
    for (let k = 0; k < this.SelectedPackageData.length; k++) {
      this.PackageDetail.push({
        PackageId: this.SelectedPackageData[k].PackageId,
        packageName: this.SelectedPackageData[k].PackageName,
        price: this.SelectedPackageData[k].serviceTotal,
        selectedPrice: this.SelectedPackageData[k].serviceTotal,
        duration: this.SelectedPackageData[k].Duration,
        PackageType: this.SelectedPackageData[k].PackageType,
        PartsTotal: this.SelectedPackageData[k].PartsTotal,
        WorkTotal: this.SelectedPackageData[k].WorkTotal,
        VM: this.SelectedPackageData[k].VM,
        SelectedPackageServices: [],
        subPackageList: [],
      });
      this.requiredservice = this.SelectedPackageData[k].PackageServiceList;
      this.TotalPrice = Number(this.TotalPrice) + Number(this.SelectedPackageData[k].serviceTotal);
      for (let i = 0; i < this.requiredservice.length; i++) {
        // if (this.BrandList.MenuPricing == "WebCapri") {
        //   this.TotalPrice = Number((this.TotalPrice + this.requiredservice[i].LineAmountVat).toFixed(2));
        // }
        // else {

        //}
        if (this.requiredservice[i].ElementType == "1") {
          this.TotalDuration = Number((this.TotalDuration + this.requiredservice[i].duration).toFixed(2));
        }
      }
      this.PackageDetail[k].SelectedPackageServices = this.requiredservice;
      // this.PackageDetail[0].subPackageList=this.subpackageList;

      // if (this.commonService.getLocalStorageitem('PackageServiceListData') != null) {
      //   var PackageDetail = this.commonService.getLocalStorage('PackageServiceListData')['SelectedPackage'];
      //   var TotalPrice = this.commonService.getLocalStorage('PackageServiceListData')['TotalPrice'];
      //   var TotalDuration = this.commonService.getLocalStorage('PackageServiceListData')['TotalDuration'];

      //    this.FinalPackageServiceData = {
      //      SelectedPackage: PackageDetail,
      //      TotalPrice: TotalPrice,
      //      TotalDuration:TotalDuration

      //   };
      // }
    }

    this.FinalPackageServiceData = {
      SelectedPackage: this.PackageDetail,
      TotalPrice: this.TotalPrice,
      TotalDuration: this.TotalDuration,
    };

    if (this.FinalPackageServiceData.SelectedPackage.length > 0) {
      this.serviceCount = this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length;
      this.selectedPackageName = this.FinalPackageServiceData.SelectedPackage[0].packageName;
    }

    if (this.SelectedPackageData.length > 0) {
      this.PriceTotal = this.FinalPackageServiceData.TotalPrice + this.AdditionalTotalPrice + this.accessoryTotalPrice + this.EUControlprice;
      this.DurationTotal = this.FinalPackageServiceData.TotalDuration + this.AdditionalTotalDuration + this.EUControlduration;
    } else {
      this.PriceTotal = this.accessoryTotalPrice + this.AdditionalTotalPrice;
      this.DurationTotal = this.AdditionalTotalDuration;
    }

    if (this.serviceCount > 0 || this.SelectedService.length > 0) {
      this.IsSubmitted = false;
    } else {
      this.IsSubmitted = true;
    }
  }

  getPackageCheckboxselected(packages: any) {
    if (this.SelectedPackageData.some((x) => x.PackageId === packages.PackageId)) {
      return true;
    } else {
      return false;
    }
  }

  public getServiceChecked() {
    if (this.commonService.getLocalStorageitem("SelectedEUService") != null) {
      this.SelectedEUService = this.commonService.getLocalStorage("SelectedEUService");
    }
    if (this.commonService.getLocalStorageitem("SelectedService") != null) {
      this.SelectedService = this.commonService.getLocalStorage("SelectedService");

      this.IsSubmitted = false;
      this.serviceCount = this.SelectedService.length;
      for (let i = 0; i < this.SelectedService.length; i++) {
        this.OLBPrice = Number((this.OLBPrice + this.SelectedService[i].TotalPrice).toFixed(2));
        this.OLBDuration = Number((this.OLBDuration + this.SelectedService[i].Duration).toFixed(2));
      }
      for (let i = 0; i < this.SelectedService.length; i++) {
        this.AdditionalTotal = Number((this.AdditionalTotal + this.SelectedService[i].LineAmountVat).toFixed(2));
        this.AddDuration = Number((this.AddDuration + this.SelectedService[i].duration).toFixed(2));
      }
      for (let i = 0; i < this.SelectedEUService.length; i++) {
        this.EUTotal = Number((this.EUTotal + this.SelectedEUService[i].LineAmountVat).toFixed(2));
        this.EUDuration = Number((this.EUDuration + this.SelectedEUService[i].duration).toFixed(2));
      }
      this.OLBServicePrice = this.OLBPrice;
      this.OLBServiceDuration = this.OLBDuration;
      this.AdditionalTotalPrice = this.AdditionalTotal;
      this.AdditionalTotalDuration = this.AddDuration;
      this.EUControlprice = this.EUTotal;
      this.EUControlduration = this.EUDuration;

      if (this.commonService.getLocalStorageitem("PackageServiceListData") != null) {
        this.PriceTotal = this.EUControlprice + this.AdditionalTotalPrice + this.accessoryTotalPrice +
          Number(this.commonService.getLocalStorage("PackageServiceListData")["TotalPrice"].toFixed(2));
        this.DurationTotal = this.EUControlduration + this.AdditionalTotalDuration +
          Number(this.commonService.getLocalStorage("PackageServiceListData")["TotalDuration"].toFixed(2));
      } else {
        this.PriceTotal = this.accessoryTotalPrice + this.EUControlprice + this.AdditionalTotalPrice;
        this.DurationTotal = this.EUControlduration + this.AdditionalTotalDuration;
      }

      this.AdditionalServiceCount = this.SelectedService.length;
      this.EUControlCount = this.SelectedEUService.length;
    }
  }

  getcheckedServices(services, event) {
    this.serviceCount = 0;
    let serviceArray = JSON.parse(JSON.stringify(this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices));
    if (event.target.checked === false) {
      if (serviceArray.length > 0) {
        const indexAt = serviceArray.findIndex((x) => x.ServiceId === services.ServiceId);
        serviceArray.splice(indexAt, 1);
        this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices = serviceArray;
        this.FinalPackageServiceData.TotalPrice = Number((this.FinalPackageServiceData.TotalPrice - services.LineAmountVat).toFixed(2));
        if (services.ElementType == "1") {
          this.FinalPackageServiceData.TotalDuration = Number((this.FinalPackageServiceData.TotalDuration - services.duration).toFixed(2));
        }
        // this.serviceCount = this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length;
        // this.FinalService.filter(x => x.PackageId === this.PackageDetail[0].PackageId)[0].selectedPrice =
        // this.SelectedPackageData.filter(x => x.PackageId == this.PackageDetail[0].PackageId)[0].selectedPrice - services.LineAmountVat;
      }
    } else {
      serviceArray.push(services);
      this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices = serviceArray;

      this.FinalPackageServiceData.TotalPrice = Number((this.FinalPackageServiceData.TotalPrice + services.LineAmountVat).toFixed(2));
      if (services.ElementType == "1") {
        this.FinalPackageServiceData.TotalDuration = Number((this.FinalPackageServiceData.TotalDuration + services.duration).toFixed(2));
      }

      this.FinalService.filter((x) => x.PackageId == this.PackageDetail[0].PackageId)[0].selectedPrice =
        this.SelectedPackageData.filter((x) => x.PackageId == this.PackageDetail[0].PackageId)[0].selectedPrice + services.LineAmountVat;
    }

    this.serviceCount = this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length;
    this.TotalPrice = this.FinalPackageServiceData.TotalPrice;
    this.TotalDuration = this.FinalPackageServiceData.TotalDuration;
    this.PriceTotal = this.FinalPackageServiceData.TotalPrice + this.AdditionalTotalPrice + this.accessoryTotalPrice + this.EUControlprice;
    this.DurationTotal = this.FinalPackageServiceData.TotalDuration + this.AdditionalTotalDuration + this.EUControlduration;
  }

  GetCheckedDetail(services) {
    if (this.requiredservice.some((x) => x.ServiceId === services.ServiceId)) {
      return true;
    } else {
      return false;
    }
  }

  public PushAdditionalService(serviceData, $event) {
    this.IsSubmitted = true;

    if (this.SelectedPackageData.length > 0) {
      this.PackagePrice = Number(this.FinalPackageServiceData.TotalPrice.toFixed(2));
      this.PackageDuration = Number(this.FinalPackageServiceData.TotalDuration.toFixed(2));
    } else {
      this.PackagePrice = 0;
      this.PackageDuration = 0;
    }

    if ($event.target.checked === false) {
      const indexAt = this.SelectedService.findIndex((x) => x.ServiceId === serviceData.ServiceId);
      this.SelectedService.splice(indexAt, 1);
      this.AdditionalTotal = Number((this.AdditionalTotal - serviceData.LineAmountVat).toFixed(2));
      this.AddDuration = Number((this.AddDuration - serviceData.duration).toFixed(2));
    } else {
      // tslint:disable-next-line:prefer-for-of
      const index = this.SelectedService.findIndex((x) => x.ServiceId === serviceData.ServiceId);
      if (index > -1) {
        this.SelectedService.splice(index, 1);
        // this.AdditionalTotal = this.AdditionalTotal - serviceData.LineAmountVat;
        //  this.AddDuration = this.AddDuration - serviceData.duration;
      } else {
        this.SelectedService.push(serviceData);
        this.AdditionalTotal = Number((this.AdditionalTotal + serviceData.LineAmountVat).toFixed(2));
        this.AddDuration = Number((this.AddDuration + serviceData.duration).toFixed(2));
      }
    }
    this.AdditionalServiceCount = this.SelectedService.length;

    this.AdditionalTotalPrice = this.AdditionalTotal;
    this.PriceTotal = this.AdditionalTotalPrice + this.PackagePrice + this.accessoryTotalPrice + this.EUControlprice;

    this.AdditionalTotalDuration = this.AddDuration;
    this.DurationTotal = this.AdditionalTotalDuration + this.PackageDuration + this.EUControlduration;

    if (this.SelectedService.length > 0 || this.FinalPackageServiceData.SelectedPackage[0].SelectedPackageServices.length > 0) {
      this.IsSubmitted = false;
    } else {
      this.IsSubmitted = true;
    }
    this.commonService.setLocalStorage("SelectedService", this.SelectedService);
  }

  public getEUCheckboxselected(euData) {
    if (this.SelectedEUService.some((x) => x.ServiceId === euData.ServiceId)) {
      return true;
    } else {
      return false;
    }
  }

  public getCheckboxselected(serviceData) {
    // this.getServiceChecked();
    //to remove below comment in main application
    // if (this.SelectedService.some(x => x.service === serviceData.ServiceId)) {
    if (this.SelectedService.some((x) => x.ServiceId === serviceData.ServiceId)) {
      return true;
    } else {
      return false;
    }
  }

  showPDFData(pack) {
    if (this.BrandCode.toLocaleLowerCase() == "mitsubishi") {
      if (pack.PackageName.toLocaleLowerCase().includes("5+"))
        this.pdfPath = "../../../assets/ServiceCheckList/Mitsubishi5PlusService.pdf";
      else
        this.pdfPath = "../../../assets/ServiceCheckList/Mitsubishi Example serivce checklist.pdf";
      this.ShowPopup("servicemodal");
    }
    else if (this.BrandCode.toLocaleLowerCase() == "renault") {
      if (pack.PackageName.toLocaleLowerCase().includes("service")) {
        if (this.FuelType != null && this.FuelType != undefined && this.FuelType.toLocaleLowerCase() == "electric")
          this.pdfPath = "../../../assets/ServiceCheckList/Serviceskjema_04 Renault EL.pdf";
        else
          this.pdfPath = "../../../assets/ServiceCheckList/Serviceskjema_03 Renault ICE.pdf";
      }
      else
        this.pdfPath = "../../../assets/ServiceCheckList/OLB mersalgsprodukter.pdf";
      this.ShowPopup("servicemodal");
    }

  }

  public ShowPopup(id) {
    if (id == "openModelPDF") {
      if (this.BrandCode == "Renault" && this.modelPDF != undefined && this.modelPDF != null && this.modelPDF != '')
        this.modalService.open(id);
    }
    else
      this.modalService.open(id);
  }


  public computeDate(date) {
    date.setDate(date.getDate() + Number(this.commonService.getLocalStorageByKey("dealerConfig", "LeadTime")));
    if (date.getDay() == 5) {
      date.setDate(date.getDate() + 3);
    } else if (date.getDay() == 6) {
      date.setDate(date.getDate() + 2);
    } else {
      date.setDate(date.getDate() + 1);
    }
    return date;
  }

  public timeConvert(n) {
    const num = Number(n);
    const hours = num / 60;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = Math.round(minutes);
    if (rhours < 0) {
      return "0.0";
    } else if (rhours == 0) {
      return hours;
    }
    return rhours + "." + rminutes;
  }

  public numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

}
